import { formatTime, getWeekday, Language } from '@hilma/netina2all';
import moment from 'moment';

export const formatTimeRange = (range: [Date, Date] | null | undefined, lng: Language) => {
    if (!range) return lng === 'he' ? 'התחנה סגורה' : 'Closed';
    const format = (date: Date | string) => moment(date).format(lng === 'he' ? 'HH:mm' : 'hh:mm A');
    return `${format(range[1])} - ${format(range[0])}`;
}

export const formatOpeningDate = (date: Date, lng: Language) => {
    return `${lng === 'he' ? 'יום ' : ''}${getWeekday(new Date(date), lng === 'he' ? 'he-IL' : 'en-US')} 
            ${moment(date).format('DD/MM/YYYY')}`
}
